import Tooltip from '@mui/material/Tooltip';

import { useTranslate } from 'src/locales';

import Label, { LabelProps } from 'src/components/label';

import Iconify from '../iconify';

type Props = {
  title?: string;
  tooltip?: string;
} & LabelProps;

export default function RestrictedInfoLabel({ title, tooltip, sx, ref, ...other }: Props) {
  const { t } = useTranslate();

  return (
    <Tooltip title={tooltip}>
      <Label variant="soft" startIcon={<Iconify icon="bitcoin-icons:hidden-filled" />} sx={{ ...sx }} {...other}>
        {title ?? t(`common.not_shared`)}
      </Label>
    </Tooltip>
  );
}
